import { useLocation } from 'react-router-dom';
import { HEADER_DISABLED_ROUTES } from 'router/config';

const useIsHeaderDisabledRoute = () => {
    const { pathname } = useLocation();

    if (HEADER_DISABLED_ROUTES.includes(pathname)) {
        return true;
    }
    return false;
};

export default useIsHeaderDisabledRoute;
